import { theme } from '@prophecy/theme';
import { Direction, Shimmer, Stack, SummaryCard, SummaryCardSize } from '@prophecy/ui-v3';
import { formatBytes } from '@prophecy/utils/fmt';

import { useBranchTab } from './BranchTabContext';

const TotalBranches = 'Total Branches';
const StorageUsed = 'Storage Used';

function formatSummaryValue(value: number | undefined) {
  return value == null ? '--' : value;
}

export const BranchesSummary = () => {
  const loading = useBranchTab(({ state }) => state.loading);
  const totalCount = useBranchTab(({ state }) => state.summary.totalCount);
  const unusedCount = useBranchTab(({ state }) => state.summary.unusedCount);
  const unusedAfterDays = useBranchTab(({ state }) => state.summary.unusedAfterDays);
  const storageUsedBytes = useBranchTab(({ state }) => state.summary.storageUsedBytes);

  return (
    <Stack
      direction={Direction.horizontal}
      gap={theme.spaces.x16}
      padding={`${theme.spaces.x24} 0 ${theme.spaces.x32} 0`}>
      <Shimmer loading={loading} fullWidth>
        <SummaryCard label={TotalBranches} value={formatSummaryValue(totalCount)} size={SummaryCardSize.large} />
      </Shimmer>
      <Shimmer loading={loading} fullWidth>
        <SummaryCard
          label={StorageUsed}
          value={storageUsedBytes == null ? '--' : formatBytes(storageUsedBytes)}
          size={SummaryCardSize.large}
        />
      </Shimmer>
      <Shimmer loading={loading} fullWidth>
        <SummaryCard
          label={`Not used in ${unusedAfterDays}+ days`}
          value={formatSummaryValue(unusedCount)}
          size={SummaryCardSize.large}
        />
      </Shimmer>
    </Stack>
  );
};
